const cartDrawer = document.querySelector("cart-drawer");
let activeElement = null;

function formatMoney(cents, format) {
  if (typeof cents == "string") {
    cents = cents.replace(".", "");
  }
  var value = "";
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || this.money_format;

  function defaultOption(opt, def) {
    return typeof opt == "undefined" ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ",");
    decimal = defaultOption(decimal, ".");

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split("."),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
      cents = parts[1] ? decimal + parts[1] : "";

    return dollars + cents;
  }

  var match = formatString.match(placeholderRegex);

  if (match) {
    switch (match[1]) {
      case "amount":
        value = formatWithDelimiters(cents, 2);
        break;
      case "amount_no_decimals":
        value = formatWithDelimiters(cents, 0);
        break;
      case "amount_with_comma_separator":
        value = formatWithDelimiters(cents, 2, ".", ",");
        break;
      case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(cents, 0, ".", ",");
        break;
    }
  }

  return formatString.replace(placeholderRegex, value);
}

const setActiveElement = (element) => {
  activeElement = element;
};

const openCartDrawer = (triggeredBy) => {
  if (triggeredBy) setActiveElement(triggeredBy);

  const cartDrawerNote = cartDrawer.querySelector('[id^="Details-"] summary');
  if (cartDrawerNote && !cartDrawerNote.hasAttribute("role")) {
    setSummaryAccessibility(cartDrawerNote);
  }

  setTimeout(() => {
    cartDrawer.classList.add("animate", "active");
  });

  const recartPopupRoot = document.querySelector("#recart-popup-root");
  if (recartPopupRoot) {
    recartPopupRoot.style.display = "none";
  }

  const html = document.querySelector("html");
  html.style.overflow = "hidden";
};

const closeCartDrawer = () => {
  cartDrawer.classList.add("closing");
  const html = document.querySelector("html");
  html.style.overflow = "auto";
  const recartPopupRoot = document.querySelector("#recart-popup-root");
  if (recartPopupRoot) {
    recartPopupRoot.style.display = "block";
  }

  setTimeout(() => {
    cartDrawer.classList.remove("active", "closing");
  }, 300);
};

const setSummaryAccessibility = (cartDrawerNote) => {
  cartDrawerNote.setAttribute("role", "button");
  cartDrawerNote.setAttribute("aria-expanded", "false");

  const nextElementId = cartDrawerNote.nextElementSibling?.getAttribute("id");
  if (nextElementId) {
    cartDrawerNote.setAttribute("aria-controls", nextElementId);
  }

  cartDrawerNote.addEventListener("click", (event) => {
    event.currentTarget.setAttribute(
      "aria-expanded",
      !event.currentTarget.closest("details").hasAttribute("open")
    );
  });

  cartDrawerNote.parentElement.addEventListener("keyup", onKeyUpEscape);
};

const setHeaderCartIconAccessibility = () => {
  const cartLink = document.querySelector("#cart-drawer-trigger");
  if (cartLink) {
    cartLink.setAttribute("role", "button");
    cartLink.setAttribute("aria-haspopup", "dialog");

    cartLink.addEventListener("click", (event) => {
      event.preventDefault();
      openCartDrawer(cartLink);
    });

    cartLink.addEventListener("keydown", (event) => {
      if (event.code.toUpperCase() === "SPACE") {
        event.preventDefault();
        openCartDrawer(cartLink);
      }
    });
  }
};

async function updateCartDrawer() {
  const res = await fetch(
    `${window.Shopify.routes.root}?section_id=cart-drawer`
  );
  const text = await res.text();
  const html = document.createElement("div");
  html.innerHTML = text;
  const newBox = html.querySelector("cart-drawer").innerHTML;
  document.querySelector("cart-drawer").innerHTML = newBox;
  addCartDrawerListeners();
}

document.addEventListener("ssp:cart:update", () => {
  updateCartDrawer();
  setTimeout(() => {
    console.log("Re-intentando la actualización del carrito después de 0.5 segundos");
    updateCartDrawer();
  }, 500); 
});

document.addEventListener("shopify:cart:updated", updateCartDrawer);


async function addToCartSubscription(form) {
  fetch("/cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-Requested-With": "XMLHttpRequest",
    },
    body: JSON.stringify(form),
  })
    .then((response) => {
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      return response.json();
    })
    .then((data) => {
      updateCartDrawer();
      openCartDrawer();
      updateBubbleCartCount(data.item_count);
    })
    .catch((error) => {
      console.error("Error:", error);
    });
}

const updateBubbleCartCount = (count) => {
  if (count === undefined) {
    return;
  }
  const cartCount = document.querySelector(
    "#CartCount"
  );
  if (cartCount) {
    cartCount.innerHTML = count;
  }
};

async function handleProductFormSubmit(e) {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);

    const button = e.submitter;
    button?.classList.add("loading");
    button?.setAttribute("aria-disabled", "true");

    const data = {};

    for (const [key, value] of formData.entries()) {
        data[key] = value;
    }
    
    const toggle = form.querySelector('#subToggle');
    if (toggle && toggle.checked) {
      const customDropdown = form.querySelector('#custom-subscription-dropdown');
      if (customDropdown && customDropdown.value) {
        data['selling_plan'] = customDropdown.value;
      }
    } else {
      if(toggle){
          delete data['selling_plan'];
      }
    }

    try {
        const response = await fetch("/cart/add.js", {
            method: "POST",
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data), 
        });

    if (!response.ok) {
        const errorData = await response.json();
        console.error('Error al agregar al carrito:', errorData);
        throw new Error('Error al agregar al carrito.');
    }

      const itemAdded = await response.json();

      const res = await fetch("/cart.js");
      const cart = await res.json();
      
      await updateCartDrawer();
      updateBubbleCartCount(cart.item_count);
      openCartDrawer();

    } catch (error) {
        console.error("Hubo un error en la solicitud:", error);
    } finally {
        button?.classList.remove("loading");
        button?.removeAttribute("aria-disabled");
    }
}
async function addCartDrawerListeners() {
  document.querySelectorAll(".quantity__button").forEach((button) => {
    button.addEventListener("click", async () => {
      const rootItem = button.closest("[data-line-item-key]");
      const key = rootItem.getAttribute("data-line-item-key");

      const currentQuantity = Number(
        button.parentElement.querySelector("input").value
      );

      const newQuantity =
        button.name === "plus" ? currentQuantity + 1 : currentQuantity - 1;

      const res = await fetch("/cart/update.js", {
        method: "post",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ updates: { [key]: newQuantity } }),
      });
      const cart = await res.json();

      updateCartDrawer();
      updateBubbleCartCount(cart.item_count);
    });
  });

  document.querySelectorAll("cart-remove-button").forEach((e) => {
    e.addEventListener("click", async () => {
      const rootItem = e.closest("[data-line-item-key]");
      const key = rootItem.getAttribute("data-line-item-key");

      const res = await fetch("/cart/update.js", {
        method: "post",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ updates: { [key]: 0 } }),
      });

      const cart = await res.json();

      updateCartDrawer();
      updateBubbleCartCount(cart.item_count);
    });
  });

  document.querySelectorAll(".drawer__header .drawer__close").forEach((el) => {
    el.addEventListener("click", () => {
      closeCartDrawer();
    });
  });

  document
    .querySelector("#CartDrawer-Overlay")
    ?.addEventListener("click", closeCartDrawer);

  cartDrawer.addEventListener(
    "keyup",
    (evt) => evt.code === "Escape" && closeCartDrawer()
  );

  document.querySelectorAll(".input-selling").forEach((checkbox) => {
    checkbox.addEventListener("change", async (event) => {
      const checkbox = event.target;
      checkbox.disabled = true;
      const lineItemKey = checkbox.dataset.lineItemKey;
      const sellingPlanId = checkbox.checked ? checkbox.dataset.sellingPlanId : null;
      
      const quantityInput = checkbox.closest(".cart-item").querySelector(".quantity__input").value;
      const currentQuantity = quantityInput ? quantityInput : 1;
  
      try {
        const response = await fetch("/cart/change.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            id: lineItemKey,
            selling_plan: sellingPlanId,
            quantity: currentQuantity, 
          }),
        });
  
        if (!response.ok) throw new Error("Error updating cart");
  
        const cart = await response.json();
  
        if (quantityInput) {
          quantityInput.value = currentQuantity;
        }
  
        await updateCartDrawer();
      } catch (error) {
        console.error("Failed to update subscription:", error);
      } finally {
        checkbox.disabled = false;
      }
    });
  });

  document.querySelectorAll(".selling-plan-select").forEach((select) => {
  select.addEventListener("change", async (event) => {
    const select = event.target;
    const sellingPlanId = select.value || null;
    const lineItemKey = select.dataset.lineItemKey;

    const cartItem = select.closest(".cart-item");
    const quantityInput = cartItem?.querySelector(".quantity__input");
    const currentQuantity = quantityInput?.value || 1;

    // Desactiva el select mientras se hace la petición
    select.disabled = true;

    try {
      const response = await fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          id: lineItemKey,
          selling_plan: sellingPlanId,
          quantity: currentQuantity,
        }),
      });

      if (!response.ok) throw new Error("Error updating cart with selling plan");

      const cart = await response.json();

      // Opcional: actualiza checkbox visualmente si lo usas en conjunto
      const checkbox = cartItem?.querySelector(".input-selling");
      if (checkbox) checkbox.checked = !!sellingPlanId;

      await updateCartDrawer();
    } catch (error) {
      console.error("Failed to update selling plan:", error);
    } finally {
      select.disabled = false;
    }
  });
});

  

  document.querySelectorAll(".fbt-form .form-product").forEach((form) => {
    form.addEventListener("submit", handleProductFormSubmit);
  });


  setHeaderCartIconAccessibility();
}

addCartDrawerListeners();

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".group-product__form").forEach((form) => {
    form.addEventListener("submit", handleProductFormSubmit);
  });

  document.querySelectorAll(".rca-add-to-cart-submit").forEach((form) => {
    form.addEventListener("submit", handleProductFormSubmit);
  });

  document.querySelectorAll(".shg-btn").forEach((button) => {
    button.addEventListener("click", (event) => {
  
      const href = button.getAttribute("href");
      const idMatch = href.match(/id=(\d+)/);
      const sellingPlanMatch = href.match(/selling_plan=(\d+)/);
  
      if (!idMatch || !sellingPlanMatch) {
        return;
      }

      event.preventDefault(); 
  
      const id = idMatch[1];
      const sellingPlanId = sellingPlanMatch[1];
  
      const payload = {
        items: [
          {
            id: parseInt(id, 10),
            quantity: 1,
            selling_plan: parseInt(sellingPlanId, 10),
          },
        ],
      };

      addToCartSubscription(payload);
  
    });
  });
  

});

